import { StyledTextFieldContainer } from './styles';
import { TTextFieldContainer } from './types';

export const TextFieldContainer = (props: TTextFieldContainer) => {
  return <StyledTextFieldContainer {...props} />;
};
